import Navigation from './components/navigation';
import Parallax from './components/parallax';
import Carousel from './components/carousel';
import Expandable from './components/expandable';
import VertCenter from './components/vertcenter';
import Map from './components/map';
import '../../node_modules/tablesaw/dist/stackonly/tablesaw.stackonly.jquery.js';
import '../../node_modules/tablesaw/dist/tablesaw-init.js';

new Navigation();
new Parallax();
new Carousel();
new Expandable();
new VertCenter();
new Map();


// WEBPACK FOOTER //
// ./src/js/root.js